import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Reviews from "components/Reviews";
import config from "config/site";
import Actions from "./Actions";
import { Row } from "./styled";
const Main = ({ isAdmin, isEditor, setIMDbId }) => (_jsx(_Fragment, { children: config.reviews.map((item) => (_jsx(Row, { children: item.rows.map((row) => (_jsx(Reviews, { actions: _jsx(Actions, { isAdmin: isAdmin, isEditor: isEditor, serviceName: row.serviceName }), name: row.name, serviceName: row.serviceName, setIMDbId: row.serviceName === "bluRay" ||
                row.serviceName === "bluRayAuthority"
                ? setIMDbId
                : undefined }, row.serviceName))) }, item.id))) }));
export default Main;
